module.exports = __webpack_public_path__ + "media/packs/landing_page/images/activities/2-ad11cda4d5068f234ebfa75c4b297c87.png";